import { Component, EventEmitter, Input, Output, AfterViewInit } from '@angular/core'
import { SearchRegion } from '../../../../../../graphql'
import { SearchRegions } from '../search-criteria-where-to-menu'

@Component({
    selector: 'app-menu-panel',
    templateUrl: './menu-panel.html',
    styleUrls: ['./menu-panel.scss']
})
export class MenuPanelComponent implements AfterViewInit {
    @Input() items: SearchRegion[] | SearchRegions[]
    @Input() selectedRegion: String
    @Output() regionSelection = new EventEmitter<SearchRegion>()

    ngAfterViewInit(): void {
        // @ViewChild not working correctly with recursive component structure - only returning top level.
        // Ugly but the only way to get the selected element correctly is using standard dom query.
        const selectedRegionEl = document.getElementsByClassName('search-criteria-selected-region')

        if (selectedRegionEl.length) {
            selectedRegionEl[0].scrollIntoView({ 
                behavior: 'smooth', 
                block: 'nearest', 
                inline: 'nearest' 
            })
        }
    }
}
